/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 */

import React from "react";
import "./signUp.css";
import CAR_IMG from "../../assets/img/motcos_car.png";

// import LayoutSignUp from "../../containers/auth/LayoutSignUp/LayoutSingUp";
import i18n from "../../services/i18n";
import RegisterForm from "../../containers/auth/RegisterForm/RegisterForm";


const SignUpPage = React.memo(() => {
  // const search = window.location.search;
  // eslint-disable-next-line compat/compat

  // const params = new URLSearchParams(search);

  return (
    <div className="sign_up_container">
      <div className="text_side">
        <div className="text_side_container">
          <h1 className="text_title"> {i18n.t("core:registerTitle")}</h1>
          <p className="text_sub_title ">{i18n.t("core:registerSubTitleStep1")}</p>
          <p className="text_description">{i18n.t("core:registerDescStep1")}</p>
          <p className="text_sub_title ">{i18n.t("core:registerSubTitleStep2")}</p>
          <p className="text_description">{i18n.t("core:registerDescStep2")}</p>
        </div>
        <img src={CAR_IMG} alt="motcos car" style={{ height: "auto", width: "100%" }} />
      </div>
      <div className="form_side">
        {/* <LayoutSignUp updateProfileData={params.get("userId")} type="registration" /> */}
        <RegisterForm />
      </div>
    </div>
  );
});

export default SignUpPage;
